<ng-container *ngIf="type === 1">
  <div class="modal-header">
    <h4 [ngClass]="{ 'modal-title': !neutralStyle }">{{ title }}</h4>
    <button
      type="button"
      class="close"
      (click)="activeModal.close()"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" tabindex="0" ngbAutofocus>
    <div class="comprovante-ponto">
      <p>{{ message }}</p>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn"
      [ngClass]="cancelButtonClass || (neutralStyle ? 'btn-outline-secondary' : 'btn-outline-danger')"
      (click)="onDismiss()"
      rippleEffect
    >
      {{ messageCancel ? messageCancel : "Cancelar (Esc)" }}
    </button>
    <button
      type="button"
      class="btn"
      [ngClass]="confirmButtonClass || (neutralStyle ? 'btn-outline-secondary' : 'btn-success')"
      *ngIf="focusConfirm"
      (click)="onConfirm()"
      rippleEffect
      #btnConfirm
    >
      {{ messageConfirm ? messageConfirm : "Confirmar (Enter)" }}
    </button>
    <button
      type="button"
      class="btn"
      [ngClass]="confirmButtonClass || (neutralStyle ? 'btn-outline-secondary' : 'btn-success')"
      *ngIf="!focusConfirm"
      (click)="onConfirm()"
      rippleEffect
      #btnConfirm
    >
      {{ messageConfirm ? messageConfirm : "Confirmar" }}
    </button>
  </div>
</ng-container>

<ng-container *ngIf="type === 2">
  <swal
    #SweetAlertHTML
    title="{{ title }}"
    text="Something went wrong!"
    html="{{ message }}"
    [icon]="icon"
    [showConfirmButton]="!!messageConfirm"
    [showCloseButton]="!!messageConfirm"
    [showCancelButton]="!!messageCancel"
    [focusCancel]="false"
    [focusClose]="false"
    [allowOutsideClick]="false"
    [swalOptions]="{
      cancelButtonClass: 'btn btn-danger ml-1',
      confirmButtonClass: 'btn btn-success'
    }"
    cancelButtonText="
      <i class=&quot;feather icon-x&quot;></i> {{ messageCancel }}
    "
    confirmButtonText="
      <i class=&quot;feather icon-check mr-25&quot;></i> {{ messageConfirm }}
    "
  >
  </swal>
</ng-container>
